/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogInputBoolean } from "../../d-dialog-input-boolean";
import { DThemeDarkDialogInput } from "./d-theme-dark-dialog-input";

export class DThemeDarkDialogInputBoolean
	extends DThemeDarkDialogInput
	implements DThemeDialogInputBoolean {}
